/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';
import { useEffect } from 'react';

import { processApplicationStore } from 'stores';

import GitSettingsDialog from './settings/GitSettingsDialog';
import gitSettingsStore from './settings/GitSettingsStore';
import GitSyncButtons from './buttons/GitSyncButtons';
import GitSyncDialog from './sync/GitSyncDialog';
import gitSyncStore from './sync/GitSyncStore';
import DeleteProviderConnectionDialog from './settings/DeleteProviderConnectionDialog';

const GitSync = () => {
  const { processApplication } = processApplicationStore;
  const { id: processApplicationId } = processApplication;

  useEffect(() => {
    if (!processApplicationId) {
      return;
    }

    gitSettingsStore.init(processApplicationId);

    return () => {
      gitSyncStore.reset();
      gitSettingsStore.reset();
    };
  }, [processApplicationId]);

  return (
    <>
      <GitSyncButtons />
      <GitSyncDialog />
      <GitSettingsDialog />
      <DeleteProviderConnectionDialog />
    </>
  );
};

export default observer(GitSync);
